module.exports = __webpack_public_path__ + "static/media/COOPV.786c06eb.png";